/* eslint-disable react/no-array-index-key */
import BrandsCenteredContent from 'components/BrandsCenteredContent';
import Skeleton from 'components/Skeleton';
import useStyles from './styles';

const BrandsTextsSkeleton = () => {
  const classes = useStyles();

  const NUMBER_OF_PARAGRAPHS = 3;

  return (
    <BrandsCenteredContent className={classes.margin}>
      <div className={classes.titleSkeleton} data-testid="BrandsTextsSkeleton">
        <Skeleton height={32} />
      </div>
      {[...Array(NUMBER_OF_PARAGRAPHS)].map((_, index) => (
        <div key={index} className={classes.textSkeleton}>
          <Skeleton height={16} />
        </div>
      ))}
    </BrandsCenteredContent>
  );
};

export default BrandsTextsSkeleton;
